import { FunnelConfig } from '~/utils/funnels';

export const I_SOLAR_UCB = 'isolarUcb';

export const config: FunnelConfig = {
  id: I_SOLAR_UCB,
  path: '/isolar-ucb',
  show: () => true,
};
